
import Vue, { PropType } from "vue";
import moment from "moment";
import { Line } from "vue-chartjs";
import _ from "lodash";

export default Vue.extend({
    extends: Line,
    data() {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                elements: {
                    line: {
                        fill: true,
                    },
                },
                scales: {
                    xAxes: [
                        {
                            type: "time",
                            ticks: {
                                source: "auto",
                            },
                            // time: {
                            //     displayFormats: {
                            //         hour: "HH:mm | DD MMM",
                            //     },
                            // },
                        },
                    ],
                },
            },
        };
    },
    props: {
        datasets: Array,
        labels: Array,
    },
    computed: {
        chartdata() {
            return {
                labels: this.labels.map((l) =>
                    moment(new Date(parseInt(l)))
                        .subtract(moment().utcOffset(), "minutes")
                        .toDate()
                        .getTime()
                ),
                datasets: this.datasets,
            };
        },
    },
    mounted() {
        
        
        this.renderChart(this.chartdata, this.options);
    },
});
